import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { AiFillDelete } from 'react-icons/ai';
import { FaUserCog, FaUserShield } from 'react-icons/fa';
import Navbar from '../../components/Navbar';
import ld from '../../images/load.gif';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from '../../styles/allusers.module.css';

function AllUsers() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(null);

  const getData = async () => {
    try {
      setLoading(true);
      const res = await axios.get('https://pro-shop-backend.vercel.app/api/users');
      if (res.data.success === true) {
        setData(res.data.users);
      } else {
        toast.error(res.data.message || 'Failed to fetch users', {
          position: 'bottom-right',
          theme: 'colored'
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      const errorMessage = error.response?.data?.message || 'Failed to fetch users. Please try again.';
      toast.error(errorMessage, {
        position: 'bottom-right',
        theme: 'colored'
      });
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const deleteHandler = async (elem) => {
    if (!window.confirm(`Are you sure you want to delete user: ${elem.name}?`)) {
      return;
    }

    try {
      setActionLoading(elem._id);
      const res = await axios.delete(`https://pro-shop-backend.vercel.app/api/users/${elem._id}`);
      
      if (res.data.success === true) {
        toast.success(res.data.message || 'User deleted successfully', {
          position: 'bottom-right',
          theme: 'colored'
        });
        getData();
      } else {
        toast.error(res.data.message || 'Failed to delete user', {
          position: 'bottom-right',
          theme: 'colored'
        });
      }
      setActionLoading(null);
    } catch (error) {
      setActionLoading(null);
      const errorMessage = error.response?.data?.message || 'Failed to delete user. Please try again.';
      toast.error(errorMessage, {
        position: 'bottom-right',
        theme: 'colored'
      });
    }
  };

  return (
    <div className={styles.allUsersContainer}>
      <Navbar />
      
      <div className={styles.allUsersContent}>
        <div className={styles.headerSection}>
          <h3 className={styles.pageTitle}>All Users</h3>
          <span className={styles.userCount}>
            {data ? `${data.length} users found` : 'Loading...'}
          </span>
        </div>

        {loading ? (
          <div className={styles.loadingContainer}>
            <img src={ld} className={styles.loaderImage} alt="Loading..." />
          </div>
        ) : data && data.length > 0 ? (
          <div className={styles.tableWrapper}>
            <table className={styles.usersTable}>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row) => (
                  <tr key={row._id} className={styles.tableRow}>
                    <td className={styles.userId}>{row._id.slice(0, 8)}...</td>
                    <td className={styles.userName}>{row.name}</td>
                    <td className={styles.userEmail}>{row.email}</td>
                    <td>
                      <span className={row.isAdmin ? styles.adminBadge : styles.userBadge}>
                        {row.isAdmin ? (
                          <>
                            <FaUserShield className={styles.badgeIcon} />
                            Admin
                          </>
                        ) : (
                          <>
                            <FaUserCog className={styles.badgeIcon} />
                            User
                          </>
                        )}
                      </span>
                    </td>
                    <td>
                      <button 
                        onClick={() => deleteHandler(row)} 
                        className={styles.deleteBtn}
                        disabled={actionLoading === row._id}
                      >
                        {actionLoading === row._id ? (
                          <img src={ld} className={styles.smallLoader} alt="loading" />
                        ) : (
                          <AiFillDelete className={styles.deleteIcon} />
                        )}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className={styles.noUsers}>
            <div className={styles.noUsersIcon}>👥</div>
            <p>No users found</p>
          </div>
        )}
      </div>
      
      <ToastContainer 
        position="bottom-right"
        theme="colored"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default AllUsers;